export const GLOBAL_ADMIN_PATHS = {
  tenants: "/global-admin/tenants",
  auditLog: "/global-admin/audit-log",
  systemHealth: "/global-admin/system-health",
  timeTravel: "/global-admin/time-travel",
};
